var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AtomTitle',{attrs:{"tag":"h2","content":_vm.description,"animation":_vm.animation}})
}
var staticRenderFns = []

export { render, staticRenderFns }